import * as PropTypes from 'prop-types'

import {
  CloseIcon,
  ExternalLinkIcon,
  IconButton,
  Tooltip,
} from '@buffer-mono/popcorn'

import { Link, UserName } from './style'

// @ts-expect-error TS(7006) FIXME: Parameter 'username' implicitly has an 'any' type.
const getUrl = (username) => `https://www.instagram.com/${username}`

// @ts-expect-error TS(7031) FIXME: Binding element 'tag' implicitly has an 'any' type... Remove this comment to see the full error message
const TagListItem = ({ tag, index, lastItem, removeTag, translations }) => (
  // @ts-expect-error TS(2769) FIXME: No overload matches this call.
  <UserName lastItem={lastItem} key={index}>
    <IconButton
      onClick={() => {
        removeTag(tag)
      }}
      variant="tertiary"
      label="Remove tag"
    >
      <CloseIcon size="small" />
    </IconButton>
    {`@${tag.username}`}
    <Link target="_blank" href={getUrl(tag.username)}>
      <Tooltip content={translations.tooltip} side="top">
        <ExternalLinkIcon size="small" color="default" />
      </Tooltip>
    </Link>
  </UserName>
)

TagListItem.propTypes = {
  tag: PropTypes.shape({
    username: PropTypes.string,
    x: PropTypes.string,
    y: PropTypes.string,
  }).isRequired,
  translations: PropTypes.shape({
    tooltip: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
  removeTag: PropTypes.func.isRequired,
  lastItem: PropTypes.bool.isRequired,
}

export default TagListItem
